import { toast } from "react-toastify";
import { apiSlice } from ".";
import { errorToast } from "../../constants/toast";

const propertiesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    changePropertyStatus: builder.mutation({
      query: ({ pstatus, agencyid, propertyid }) => ({
        url: `/PropertyTables/UpdatePropertyStatus/${propertyid}?stat=${pstatus}`,
        method: "POST",
        body: { pstatus },
      }),

      async onQueryStarted(
        { pstatus, agencyid, propertyid },
        { dispatch, queryFulfilled }
      ) {
        // const editResult = dispatch(
        //   propertiesApi.util.updateQueryData("getAgencyProperties", agencyid, (properties) => {
        //     return properties.map((item) =>
        //       item.propertyid === propertyid ? { ...item, pstatus: pstatus } : item
        //     );
        //   })
        // );

        try {
          await queryFulfilled;
        } catch (err) {
          errorToast(
            `Error while changing status for the property Id ${propertyid}, Refresh page and try again`
          );
          dispatch(propertiesApi.util.invalidateTags(["AgencyProperties"]));
        }
      },
    }),

    getPropertyById: builder.query({
      query: (propertyId) => `/PropertyTables/GetPropertyTable/${propertyId}`,
    }),

    getPropertyImages: builder.query({
      query: (propertyId) =>
        `/PropertyImagesTables/GetImageByPropertyID/${propertyId}`,
      providesTags: ["PropertyImages"],
    }),
    addProperty: builder.mutation({
      query: ({ agcid, ...body }) => ({
        url: `/FileUploader/PropertyAdding?agcid=${String(agcid)}`,
        method: "POST",
        body,
        formData: true,
      }),

      // invalidatesTags: ["Properties"],

      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Adding Property",
          success: "Property Added",
          error: "Error Adding Property",
        });
      },
    }),
    editProperty: builder.mutation({
      query: (data) => ({
        url: `/FileUploader/PropertyInfoAfterEditing/${data.propertyid}`,
        method: "POST",
        body: data,
      }),

      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Editing Property",
          success: "Property Edited",
          error: "Error Editing Property",
        });
      },
    }),
    addImages: builder.mutation({
      query: (data) => ({
        url: `/FileUploader/uploadfilesByID2?location=${data.watermark.location}&opacity=${data.watermark.opacity}&logosize=${data.watermark.size}&logoFileName=${data.watermark.name}`,
        method: "POST",
        body: data.formData,
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Uploading Images",
          success: "Images Uploaded",
          error: "Error Uploading Images",
        });
      },
    }),

    // redux/api/properties.js
    getAgencyProperties: builder.query({
      query: ({ agencyId, propstat, pageNumber, pageSize = 10 }) => {
        const params = new URLSearchParams();
        params.set("agcid", agencyId);

        if (propstat !== undefined && propstat !== null && propstat !== "all") {
          params.set("propstat", propstat);
        }
        if (Number.isFinite(pageNumber)) {
          params.set("pageNumber", String(pageNumber));
        }
        if (Number.isFinite(pageSize)) {
          params.set("pageSize", String(pageSize));
        }

        return `/PropertyTables/GetPropByAgencyidAndPropstatus?${params.toString()}`;
      },
      providesTags: ["AgencyProperties"],
    }),

    deleteProperty: builder.mutation({
      query: ({ propertyId, agencyId }) => ({
        url: `/PropertyTables/DeletePropertyTable/${propertyId}`,
        method: "POST",
      }),

      async onQueryStarted(
        { propertyId, agencyId },
        { dispatch, queryFulfilled }
      ) {
        // const deleteResult = dispatch(
        //   propertiesApi.util.updateQueryData("getAgencyProperties", agencyId, (properties) => {
        //     return properties.filter((item) => item.propertyid !== propertyId);
        //   })
        // );

        try {
          await queryFulfilled;
        } catch (err) {
          errorToast(
            `Error while deleting Property ${propertyId}, Refresh page and try again`
          );
          dispatch(propertiesApi.util.invalidateTags(["AgencyProperties"]));
        }
      },
    }),

    getAddedProperty: builder.query({
      query: (propertyId) => `/PropertyFilter/Gettt?propid=${propertyId}`,
    }),
  }),
});

export const {
  useChangePropertyStatusMutation,
  useGetAgencyPropertiesQuery,
  useDeletePropertyMutation,
  useGetPropertyByIdQuery,
  useGetPropertyImagesQuery,
  useEditPropertyMutation,
  useAddImagesMutation,
  useAddPropertyMutation,
  useLazyGetAddedPropertyQuery,
} = propertiesApi;
